import {BasicService} from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_PRODUCTION_LINE_URL } from '../../connection.data';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ProductionLineService extends BasicService {
    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_PRODUCTION_LINE_URL;
    }
}